import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  MIDDLE_WARE_BASE_URL,
  GET_LEAVE_REQUEST_ATTACHMENTS,
} from "../../constants";
import axios from "../../datasource/axios-instance";

const initialState = {
 LeaveRequestAttachmentStatus: null,
 LeaveRequestAttachmentState: null,
 LeaveRequestAttachmentDetailsData: null,
};

export const getLeaveRequestAttachment = createAsyncThunk(
  "get/getLeaveRequestAttachment",
  async (data: any) => {
    const response = await axios.getRequest(
      MIDDLE_WARE_BASE_URL() +
      GET_LEAVE_REQUEST_ATTACHMENTS() +
        `?requestId=${data.requestId}&createdBy=${data.createdBy}${data.attachmentname ? '&attachmentname=' + data.attachmentname : ''}${data.attachmentname1 ? '&attachmentname1=' + data.attachmentname1 : ''}`
    );
    return response;
  }
);

export const getLeaveRequestAttachmentSlice = createSlice({
  name: "getLeaveRequestAttachment",
  initialState,
  reducers: {},
  extraReducers: (builder: any) =>
    builder
      .addCase(getLeaveRequestAttachment.pending, (state: any) => {
        state.LeaveRequestAttachmentState = "pending";
      })
      .addCase(getLeaveRequestAttachment.fulfilled, (state: any, action: any) => {
        state.LeaveRequestAttachmentState = "fulfilled";
        state.LeaveRequestAttachmentStatus = "success";
        state.LeaveRequestAttachmentDetailsData = action.payload.data;
      })
      .addCase(getLeaveRequestAttachment.rejected, (state: any) => {
        state.LeaveRequestAttachmentState = "failed";
        state.LeaveRequestAttachmentStatus = "fail";
      }),
});

export const getLeaveRequestAttachmentDetails = (state: any) =>
  state.getLeaveRequestAttachment || {};

export default getLeaveRequestAttachmentSlice.reducer;